/* eslint-disable no-restricted-globals */
export const goTo = (url) => {
  window.location.replace(url);
};

export const getLocation = () => location.href;
